import React, { useState, useEffect } from 'react';

import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Checkbox,
    Skeleton,
    TableContainer,
    FormControl,
    Select,
    Menu,
    MenuItem,
       Button

} from '@mui/material';
import EditReason from '../../../../components/Projects/EditReason';
import DeleteReasonFields from '../../../../components/Projects/DeleteReason'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
const projects = [
    {
        name: 'Vansh Saini',
    },
    {
        name: 'Devon Lane',
    },
    {
        name: 'Leslie Alexander',
    },
];
const roles = [
    { label: 'Edit', },
    { label: 'Delete', },
];

const CustomCheckbox = ({ checked, onChange }) => (

    <Checkbox
        checked={checked}
        onChange={onChange}
        icon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '4px',
                    border: '1px solid #D0D5DD',
                    backgroundColor: '#E5E8EB',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
        checkedIcon={
            <Box
                sx={{
                    width: 24,
                    height: 24,
                    borderRadius: '4px',
                    backgroundColor: '#1976d2',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M20 6L9 17L4 12"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </Box>
        }
    />
);

const RequirePersonData = () => {
    const [loading, setLoading] = useState(true);
    const [selectedValues, setSelectedValues] = useState([]);


    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    const handleCheckboxChange = (name) => {
        setSelectedValues((prev) =>
            prev.includes(name) ? prev.filter((item) => item !== name) : [...prev, name]
        );
    };

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedValues(projects.map((p) => p.name));
        } else {
            setSelectedValues([]);
        }
    };


    const [role, setRole] = useState('');

    const handleChangeUser = (event) => {
        setRole(event.target.value);
    };
    
        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);
    
        const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
        };
    
        const handleClose = () => {
            setAnchorEl(null);
        };
    
    const [openEditCustom, setOpenEditCustom] = useState(false);
    const [openDelCustomField, setOpenDelCustomField] = useState(false);
    return (
        <div>
            <TableContainer sx={{ boxShadow: 'none' }}>
                <Table className='shadow-none' sx={{ boxShadow: 'none', borderCollapse: 'separate', }}>
                    <TableHead>
                        <TableRow sx={{
                            backgroundColor: '#DFDFDF',
                            '& th:first-of-type': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
                            '& th:last-of-type': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
                        }}>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px' }} padding="checkbox">
                                <CustomCheckbox
                                    checked={projects.length > 0 && selectedValues.length === projects.length}
                                    onChange={handleSelectAll} />
                            </TableCell>
                            <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>#</TableCell>
                            <TableCell colSpan={2} sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}>Name</TableCell>
                            {/* <TableCell sx={{ fontFamily: 'Manrope', color: '#626262', py: '2px', fontSize: '14px', fontWeight: '500', padding: '0px 16px', height: '50px', lineHeight: '0' }}></TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody sx={{ backgroundColor: '#fff' }}>
                        {loading
                            ? [...Array(4)].map((_, i) => (
                                <TableRow key={i}>
                                    {[...Array(4)].map((_, j) => (
                                        <TableCell key={j}><Skeleton variant="text" /></TableCell>
                                    ))}
                                </TableRow>
                            ))
                            : projects.map((project, index) => (
                                <TableRow key={index} sx={{
                                    borderRadius: '8px',
                                    '& td:first-of-type': { borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' },
                                    '& td:last-of-type': { borderTopRightRadius: '8px', borderBottomRightRadius: '8px' },
                                }}>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }} padding="checkbox">
                                        <CustomCheckbox
                                            checked={selectedValues.includes(project.name)}
                                            onChange={() => handleCheckboxChange(project.name)}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px', fontFamily: 'Manrope' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', py: '10px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>

                                            <Box>
                                                <Typography sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>
                                                    {project.name}
                                                </Typography>

                                            </Box>
                                        </Box>
                                    </TableCell>
                            <TableCell sx={{ borderBottom: 'none', whiteSpace: 'nowrap', fontFamily: 'Manrope' }} align='center'>
                                        <Box display="flex" justifyContent="end">
                                        <Button
                                            variant="outlined"
                                            endIcon={<KeyboardArrowDownIcon />}
                                            onClick={handleClick}
                                            sx={{
                                                borderRadius: '100px',
                                                textTransform: 'none',
                                                borderColor: '#0076FE',
                                                color: '#0076FE',
                                                fontWeight: 600,
                                                fontSize: '16px',
                                                fontFamily: 'Manrope',
                                                height: '36px',
                                                width: '140px',
                                                justifyContent: 'space-around',
                                            }}
                                        >
                                            Action
                                        </Button>
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={open}
                                            onClose={handleClose}
                                            PaperProps={{
                                                elevation: 3,
                                                sx: {
                                                    borderRadius: 2,
                                                    minWidth: 180,
                                                    mt: 0,
                                                    boxShadow: '0 0 4px #00000026',
                                                },
                                            }}
                                        >
                                            <MenuItem onClick={() => { setOpenEditCustom(true); handleClose(); }} sx={{ fontSize: '14px', color: '#1A1F36', fontFamily: 'Manrope' }} >Edit</MenuItem>
                                            <MenuItem onClick={() => {setOpenDelCustomField(true); handleClose(); }} sx={{ fontSize: '14px', color: '#1A1F36', fontFamily: 'Manrope' }} >Delete</MenuItem>



                                        </Menu>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>

                </Table>
            </TableContainer>
            <EditReason open={openEditCustom} onClose={() => setOpenEditCustom(false)} />
            <DeleteReasonFields open={openDelCustomField} onClose={() => setOpenDelCustomField(false)} />
        
        </div>
    )
}

export default RequirePersonData
